import { instance } from './index';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import moment from 'moment';

const contextPath = '/admin/asset'

export const useGetInoutInfo = (param) => {
    const sendParam = {
        sno: param && param.sno && param.sno > 0 ? param.sno : 0,
        iot_tp: param && param.iot_tp && param.iot_tp !== '' ? param.iot_tp : '',
        sdate: param && param.sdate && param.sdate !== '' ? param.sdate : moment().subtract(1,'year').format('yyyyMMDD'),
        edate: param && param.edate && param.edate !== '' ? param.edate : moment().format('yyyyMMDD'),
        is_ing: param && param.is_ing && param.is_ing !== '' ? param.is_ing : undefined,
        row_no: param && param.row_no && param.row_no !== 10 ? param.row_no : 0, 
        row_cnt: param && param.row_cnt && param.row_cnt > 0 ? param.row_cnt : 10000,
    }
    return useQuery('ASSET_INOUT_INFO', () => getInout(sendParam));
}

const getInout = async (param) => {
    const retVal = await instance.get(contextPath+'/inouts', {params:param})
                                    .then((res)=>{
                                        return res.data[0];
                                    })
                                    // .catch((err)=>{
                                    //     return err;
                                    // })
    return retVal;
}

export const useGetInoutSel = (param) => {
    const sendParam = {
        sno: param && param.sno && param.sno > 0 ? param.sno : 0,
        iot_tp: param && param.iot_tp && param.iot_tp !== '' ? param.iot_tp : '',
        sub_tp: param && param.sub_tp && param.sub_tp !== '' ? param.sub_tp : '',
        sdate: param && param.sdate && param.sdate !== '' ? param.sdate : moment().subtract(1,'year').format('yyyyMMDD'),
        edate: param && param.edate && param.edate !== '' ? param.edate : moment().format('yyyyMMDD'),
        cid: param && param.cid && param.cid > 0 ? param.cid : 0,
        work_id: param && param.work_id && param.work_id > 0 ? param.work_id : 0,
        is_ing: param &&  param.is_ing > -1 ? param.is_ing : undefined,
        row_no: param && param.row_no && param.row_no !== 10 ? param.row_no : 0, 
        row_cnt: param && param.row_cnt && param.row_cnt > 0 ? param.row_cnt : 10000,
    }
    return useQuery('ASSET_INOUT_SEL', () => getInoutSel(sendParam));
}
const getInoutSel = async (param) => {
    const retVal = await instance.get(contextPath+'/inouts', {params:param})
                                    .then((res)=>{
                                        return res.data[0];
                                    })
                                    // .catch((err)=>{
                                    //     return err;
                                    // })
    return retVal;
}

export const useSetInout = () => {
    const queryClient = useQueryClient();
    return useMutation(
        (sendParam) => {
            switch(sendParam.mode){
                case 'POST':
                    return postInout(sendParam);
                case 'PUT':
                    return putInout(sendParam);
                case 'IS_ING':
                    return putInoutIsIng(sendParam);
                case 'DELETE':
                    return deleteInout(sendParam);
                default :
                    return putInout(sendParam);
            }
        },
        {
            onSuccess:()=>{
                queryClient.invalidateQueries('ASSET_INOUT_SEL', { refetchInactive: true })
            },
        }
    )
}

const postInout = async (param) => {

    const sendParam = {
        iot_nm: param.iot_nm,
        iot_tp: param.iot_tp,
        sub_tp: param.sub_tp,
        reg_id: param.reg_id,
        cid: param.cid,
        work_id: param.work_id,
        contents: param.contents,
        descr: param.descr,
        is_ing: param.is_ing,
        is_use: 1,
    }

    const retVal = await instance.post(contextPath+'/inouts', sendParam)
                                    .then((res)=>{
                                        return res;
                                    })
                                    // .catch((err)=>{
                                    //     return err;
                                    // })
    return retVal;
}

const putInout = async (param) => {

    const sendParam = {
        sno: param.sno,
        iot_nm: param.iot_nm,
        iot_tp: param.iot_tp,
        sub_tp: param.sub_tp,
        reg_id: param.reg_id,
        cid: param.cid,
        work_id: param.work_id,
        contents: param.contents,
        descr: param.descr,
        is_ing: param.is_ing,
        is_use: 1,
    }

    const retVal = await instance.put(contextPath+'/inouts', sendParam)
                                    .then((res)=>{
                                        return res;
                                    })
                                    // .catch((err)=>{
                                    //     return err;
                                    // })
    return retVal;
}

const putInoutIsIng = async (param) => {
    const sendParam = {
        sno: param.sno,
        is_ing: param.is_ing,
    }

    const retVal = await instance.put(contextPath+'/inoutStatus', sendParam)
                                    .then((res)=>{
                                        return res;
                                    })
                                    // .catch((err)=>{
                                    //     return err;
                                    // })
    return retVal;
}

const deleteInout = async (param) => {

    const sendParam = {
        sno: param.sno,
    }

    const retVal = await instance.put(contextPath+'/delInouts', sendParam)
                                    .then((res)=>{
                                        return res;
                                    })
                                    // .catch((err)=>{
                                    //     return err;
                                    // })
    return retVal;
}

export const useGetInoutHistSel = (param) => {

    const sendParam = {
        sno: param && param.sno && param.sno > 0 ? param.sno : 0,
        io_st: param && param.io_st && param.io_st !== '' ? param.io_st : '',
        row_no: param && param.row_no && param.row_no !== 10 ? param.row_no : 0, 
        row_cnt: param && param.row_cnt && param.row_cnt > 0 ? param.row_cnt : 10000,
    }

    return useQuery('ASSET_INOUT_HIST_SEL', () => getInoutHistSel(sendParam));
}
const getInoutHistSel = async (param) => {
    if(param.sno !== 0){
        const retVal = await instance.get(contextPath+'/inoutsHistIO', {params:param})
                                        .then((res)=>{
                                            return res.data[0];
                                        })
                                        // .catch((err)=>{
                                        //     return err;
                                        // })
        return retVal;
    }
}

export const useSetInoutHist = () => {
    const queryClient = useQueryClient();
    return useMutation(
        (sendParam) => {
            switch(sendParam.mode){
                case 'POST':
                    return postInoutHist(sendParam);
                case 'PUT':
                    return putInoutHist(sendParam);
                case 'DELETE':
                    return deleteInoutHist(sendParam);
                case 'POST_LIST':
                    return postInoutHistList(sendParam);
                default :
                    return putInoutHist(sendParam);
            }
        },
        {
            onSuccess:()=>{
                queryClient.invalidateQueries('ASSET_INOUT_HIST_SEL', { refetchInactive: true })
            },
        }
    )
}

const postInoutHist = async (param) => {

    const sendParam = {
        sno: param.sno,
        tid: param.tid,
        rid: param.rid,
        reg_id: param.reg_id,
        io_st: param.io_st,
        ret_st: param.ret_st,
        pri_check: param.pri_check,
        rel_check: param.rel_check,
        contents: param.contents,
        descr: param.descr
    }

    const retVal = await instance.post(contextPath+'/inoutsHist', sendParam)
                                    .then((res)=>{
                                        return res;
                                    })
                                    // .catch((err)=>{
                                    //     return err;
                                    // })
    return retVal;
}

const postInoutHistList = async (param) => {

    const sendParam = param.list;
    const retVal = await instance.post(contextPath+'/inoutsHistList', sendParam)
                                    .then((res)=>{
                                        return res;
                                    })
                                    // .catch((err)=>{
                                    //     return err;
                                    // })
    return retVal;
}

const putInoutHist = async (param) => {

    const sendParam = {
        seq: param.seq,
        sno: param.sno,
        tid: param.tid,
        rid: param.rid,
        reg_id: param.reg_id,
        io_st: param.io_st,
        ret_st: param.ret_st,
        pri_check: param.pri_check,
        rel_check: param.rel_check,
        contents: param.contents,
        descr: param.descr
    }

    const retVal = await instance.put(contextPath+'/inoutsHist', sendParam)
                                    .then((res)=>{
                                        return res;
                                    })
                                    // .catch((err)=>{
                                    //     return err;
                                    // })
    return retVal;
}

const deleteInoutHist = async (param) => {

    const sendParam = {
        seq: param.seq,
    }

    const retVal = await instance.put(contextPath+'/delInoutsHist', sendParam)
                                    .then((res)=>{
                                        return res;
                                    })
                                    // .catch((err)=>{
                                    //     return err;
                                    // })
    return retVal;
}

export const useGetInoutHistItem = (param) => {

    const sendParam = {
        tid: param && param.tid && param.tid > 0 ? param.tid : '',
        sno: param && param.sno && param.sno > 0 ? param.sno : '0',
    }

    return useQuery('ASSET_INOUT_HIST_ITEM', () => getInoutHistItem(sendParam));
}
const getInoutHistItem = async (param) => {
    if(param.tid !== 0 || param.sno !== 0){
        const retVal = await instance.get(contextPath+'/inoutsHistItem', {params:param})
                                        .then((res)=>{
                                            return res.data[0];
                                        })
                                        // .catch((err)=>{
                                        //     return err;
                                        // })
        return retVal;
    }
}

export const useGetInoutHistStatic = (param) => {

    const sendParam = {
        cid: param && param.cid && param.cid > 0 ? param.cid : undefined,
        tid: param && param.tid && param.tid > 0 ? param.tid : undefined,
        iot_tp: param && param.iot_tp && param.iot_tp > 0 ? param.iot_tp : undefined,
        io_st: param && param.io_st && param.io_st > 0 ? param.io_st : undefined,
        sdate: param && param.sdate && param.sdate !== '' ? param.sdate : moment().subtract(1,'year').format('yyyyMMDD'),
        edate: param && param.edate && param.edate !== '' ? param.edate : moment().format('yyyyMMDD'),
        row_no: param && param.row_no && param.row_no !== 10 ? param.row_no : 0, 
        row_cnt: param && param.row_cnt && param.row_cnt > 0 ? param.row_cnt : 10000,
    }

    return useQuery('ASSET_INOUT_HIST_STATIC', () => getInoutHistStatic(sendParam));
}
const getInoutHistStatic = async (param) => {
    if(param.tid !== 0 || param.sno !== 0){
        const retVal = await instance.get(contextPath+'/inoutHistStatic', {params:param})
                                        .then((res)=>{
                                            return res.data[0];
                                        })
                                        // .catch((err)=>{
                                        //     return err;
                                        // })
        return retVal;
    }
}

export const useGetInoutStatic = (param) => {
    const sendParam = {
        sdate: param && param.sdate && param.sdate !== '' ? param.sdate : moment().subtract(1,'year').format('yyyyMMDD'),
        edate: param && param.edate && param.edate !== '' ? param.edate : moment().format('yyyyMMDD'),
        iot_tp: param && param.iot_tp && param.iot_tp !== '' ? param.iot_tp : undefined,
        is_ing: param && param.is_ing && param.is_ing !== '' ? param.is_ing : undefined,
    }

    return useQuery('ASSET_INOUT_STATIC', () => getInoutStatic(sendParam));
}
const getInoutStatic = async (param) => {
    const retVal = await instance.get(contextPath+'/inoutStatic', {params:param})
                                    .then((res)=>{
                                        return res.data[0];
                                    })
                                    // .catch((err)=>{
                                    //     return err;
                                    // })
    return retVal;
}

export const useGetInoutStatusStatic = () => {
    // const sendParam = {
    //     sdate: param && param.sdate && param.sdate !== '' ? param.sdate : moment().subtract(1,'year').format('yyyyMMDD'),
    //     edate: param && param.edate && param.edate !== '' ? param.edate : moment().format('yyyyMMDD'),
    //     iot_tp: param && param.iot_tp && param.iot_tp !== '' ? param.iot_tp : undefined,
    //     is_ing: param && param.is_ing && param.is_ing !== '' ? param.is_ing : undefined,
    // }

    return useQuery('ASSET_INOUT_STATUS_STATIC', () => getInoutStatusStatic());
}

const getInoutStatusStatic = async () => {
    const retVal = await instance.get(contextPath+'/inoutStatusStatic', {})
                                    .then((res)=>{
                                        return res.data[0];
                                    })
                                    // .catch((err)=>{
                                    //     return err;
                                    // })
    return retVal;
}
